module.exports = __webpack_public_path__ + "static/media/banner-two.c6bee2f2.png";